import React from 'react';

const SkeletonCard: React.FC = () => (
  <div className="vc-card vc-skeleton">
    <div className="vc-img-wrapper sk-img" />
    <div className="vc-body">
      <div className="sk-line sk-title" />
      <div className="sk-line sk-short" />
      <div className="sk-line sk-med" />
      <div className="sk-line sk-btn" />
    </div>
  </div>
);

export const SkeletonGrid: React.FC<{ count?: number }> = ({ count = 6 }) => (
  <div className="ms-grid">
    {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
  </div>
);

export default SkeletonCard;
